import { render, staticRenderFns } from "./Modelo145.vue?vue&type=template&id=0188efd8&scoped=true&"
import script from "./Modelo145.vue?vue&type=script&lang=js&"
export * from "./Modelo145.vue?vue&type=script&lang=js&"
import style0 from "./Modelo145.vue?vue&type=style&index=0&id=0188efd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0188efd8",
  null
  
)

export default component.exports